import styled from 'styled-components';

export const Input = styled.input`
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px 8px;
    background: #fefefe;
`;
